export default __webpack_public_path__ + "img/web-FiveRank-68190449.png";